import type { Playbook, Offer } from "../types";

const offer = (o: Omit<Offer, "sendsPrompt"> & Partial<Pick<Offer, "sendsPrompt">>): Offer => o;

export const emailPlaybooks: Playbook[] = [
  {
    app: "email",
    priority: 90,
    match: (s) =>
      s.surface === "compose" && s.facts?.subject_empty
        ? offer({
            key: "email.compose.subject",
            app: "email",
            titleKey: "assistant.mochi.offers.email.subject.title",
            bodyKey: "assistant.mochi.offers.email.subject.body",
            ctaKey: "assistant.mochi.offers.email.subject.cta",
            promptKey: "assistant.mochi.offers.email.subject.prompt",
          })
        : null,
  },
  {
    app: "email",
    priority: 80,
    match: (s) =>
      s.surface === "compose" && s.facts?.attachment_count === 0 && s.facts?.body_mentions_attachment
        ? offer({
            key: "email.compose.attachment",
            app: "email",
            sendsPrompt: false,
            titleKey: "assistant.mochi.offers.email.attachment.title",
            bodyKey: "assistant.mochi.offers.email.attachment.body",
            ctaKey: "assistant.mochi.offers.email.attachment.cta",
            promptKey: "",
          })
        : null,
  },
  {
    app: "email",
    priority: 70,
    match: (s) =>
      s.surface === "thread" && s.item_id
        ? offer({
            key: "email.thread.reply",
            app: "email",
            titleKey: "assistant.mochi.offers.email.reply.title",
            bodyKey: "assistant.mochi.offers.email.reply.body",
            ctaKey: "assistant.mochi.offers.email.reply.cta",
            promptKey: "assistant.mochi.offers.email.reply.prompt",
            promptVars: { item_id: s.item_id },
          })
        : null,
  },
  {
    app: "email",
    priority: 10,
    match: (s) =>
      s.surface === "inbox"
        ? offer({
            key: "email.inbox.new",
            app: "email",
            titleKey: "assistant.mochi.offers.email.new.title",
            bodyKey: "assistant.mochi.offers.email.new.body",
            ctaKey: "assistant.mochi.offers.email.new.cta",
            promptKey: "assistant.mochi.offers.email.new.prompt",
          })
        : null,
  },
];
